// ResizeObserver raises "loop completed with undelivered notifications" when a
// callback changes layout and the browser cannot deliver every notification in
// the same frame. It is benign - the rest go out next frame - but the dev
// overlay treats any window error as fatal and covers the whole app.
//
// Virtualised tables hit this constantly: rows are measured with a
// ResizeObserver, and measuring feeds a size back that changes layout again.
//
// Running the callback on the next animation frame takes the work out of the
// observation cycle, so there is nothing left undelivered and the error stops
// being raised at all. contentRect on each entry is a snapshot taken at
// observation time, so nothing is lost by reading it a frame later.
// Returns a restore function so a caller can scope the patch to its own
// mount lifecycle instead of leaving it applied for the whole app.
const deferResizeObserverCallbacks = () => {
	const Native = window.ResizeObserver;
	if (!Native || Native.__deferred) return () => {};

	class DeferredResizeObserver extends Native {
		constructor(callback) {
			let frame = null;
			super((entries, observer) => {
				if (frame) cancelAnimationFrame(frame);
				frame = requestAnimationFrame(() => {
					frame = null;
					callback(entries, observer);
				});
			});
		}
	}
	DeferredResizeObserver.__deferred = true;

	window.ResizeObserver = DeferredResizeObserver;

	return () => {
		window.ResizeObserver = Native;
	};
};

export default deferResizeObserverCallbacks;
